<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Deals Transaction</h4>
          </div>
          <div class="col-6 text-right" v-show="accessObject?.is_add == 1">
            <a
              style="padding-left: 20px; padding-right: 20px; cursor: pointer"
              v-on:click="$router.push('/add-deals-transaction')"
              class="add-btn"
              >Add</a
            >
            <a href="javascript:void(0)" 
              @click="openOffcanvas"  
              class="add-btn ml-2" 
              style="padding-left: 20px; padding-right: 20px; cursor: pointer"
              v-if="$helperService.canExportAndPdf(role)"
              >
              Send Email
            </a>
            <a href="javascript:void(0)" 
              @click="downloadPdf" 
              class="add-btn ml-2 px-3 w-auto py-1" 
              style="height:28px" 
              v-if="$helperService.canExportAndPdf(role)"
              >
              Download PDF
            </a>
            <a href="javascript:void(0)" 
              @click="downloadHtml" 
              class="add-btn ml-2 px-3 w-auto py-1" 
              style="height:28px"
              v-if="$helperService.canExportAndPdf(role)"
              >
              <span v-if="downloadHtmlLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              <span v-if="!downloadHtmlLoading">Download HTML</span>
              <span v-else>Downloading...</span>
            </a>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="px-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <!-- <form class="form-search form-inline"> -->
                  <Field
                    name="keyword"
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                    style="border: 0px none; width: 100%"
                  />
                  <!-- </form> -->
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div class="row">

              <!-- Current Company Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Current Company</label>
                <Multiselect
                  mode="single"
                  trackBy="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.company_id"
                  :options="companyList"
                  searchable="true"
                  v-on:change="geteComponydetail($event)"
                  @search-change="searchCompanyName($event)"
                />
              </div>

              <!-- Industry Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Industry</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.industry_id"
                  :options="industryList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchIndustryName($event)"
                  v-on:change="industryChange($event)"
                />
              </div>

              <!-- Subsector Dropdown -->
              <div class="col-lg-2 col-sm-4 col-6" v-if="showSubsectorDropdown">
                <label class="label">Subsector</label>
                <Multiselect
                  mode="single"
                  trackBy="industry_name"
                  label="industry_name"
                  valueProp="id"
                  v-model="searchObj.subsector_id"
                  :options="subsectorsList"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Deal Type -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Deal Type</label>
                <Multiselect
                  mode="single"
                  trackBy="topic_name"
                  label="topic_name"
                  valueProp="id"
                  v-model="searchObj.topic_id"
                  :options="topicList"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Deal Stage -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Deal Stage</label>
                <Multiselect
                  mode="single"
                  trackBy="name"
                  label="name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.deal_stage_id"
                  :options="dealStageList"
                  searchable="true"
                />
              </div>

              <!-- Company Type -->
               <div class="col-lg-2 col-sm-4 col-6" v-if="!showSubsectorDropdown">
                <label class="label">Company Type</label>
                <Multiselect
                  mode="single"
                  trackBy="value"
                  label="value"
                  valueProp="id"
                  v-model="searchObj.company_type"
                  :options="company_types"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Apply & Reset -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label></label>
                <button
                  type="button"
                  style="margin-top: 23px; width: 50%"
                  v-on:click="getList(0)"
                  @click="showHeadingPopup()"
                  class="apply-btn mr-1"
                >
                  Apply
                </button>
                <button
                  v-on:click="resetFilter()"
                  type="button"
                  style="margin-top: 23px; width: 40%"
                  class="apply-btn"
                >
                  Reset
                </button>
                <div class="text-center">
                  <a
                    style="cursor: pointer"
                    v-on:click="getAdvanceSearch()"
                    class="advance-search"
                    >{{ is_show ? "Hide Advance Search" : "Advance Search" }}</a
                  >
                </div>
                <!--  <div class="text-center"><a href="#" class="advance-search">Advance Search</a></div> -->
              </div>
            </div>
            <div v-show="is_show" class="row advasearch-data mt-1">
              
              <!-- Company Type -->
               <div class="col-lg-2 col-sm-4 col-6" v-if="showSubsectorDropdown">
                <label class="label">Company Type</label>
                <Multiselect
                  mode="single"
                  trackBy="value"
                  label="value"
                  valueProp="id"
                  v-model="searchObj.company_type"
                  :options="company_types"
                  searchable="true"
                  placeholder="Select"
                />
              </div>

              <!-- Location -->
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Location</label>
                <Multiselect
                  mode="single"
                  trackBy="country_name"
                  label="country_name"
                  valueProp="id"
                  v-model="searchObj.country_id"
                  :options="cityList"
                  searchable="true"
                  placeholder="Select"
                  @search-change="searchCityName($event)"
                />
              </div>

              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Region</label>
                <Multiselect
                  mode="single"
                  trackBy="region_name"
                  label="region_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.region_id_new"
                  :options="regionList"
                  searchable="true"
                />
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">From Date</label>
                <datepicker
                  v-model="searchObj.from_date"
                  inputFormat="dd/MM/yyyy"
                  placeholder="From Date"
                  class="form-control"
                  style="background-color: white !important;"
                  :clearable="false"
                  :upperLimit="searchObj.to_date ? searchObj.to_date : new Date()"
                  v-on:click="searchObj.date_period = ''"
                >
                </datepicker>
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">To Date</label>
                <datepicker
                  v-model="searchObj.to_date"
                  inputFormat="dd/MM/yyyy"
                  class="form-control"
                  placeholder="To Date"
                  :clearable="false"
                  style="background-color: white !important;"
                  :lowerLimit="searchObj.from_date ? searchObj.from_date : null"
                  :upperLimit="new Date()"
                  v-on:click="searchObj.date_period = ''"
                >
                </datepicker>
              </div>
              <div class="col-lg-2 col-sm-4 col-6">
                <label class="label">Date period</label>
                <div class="form-group mb-3">
                  <Multiselect
                    mode="single"
                    trackBy="value"
                    label="value"
                    valueProp="id"
                    v-model="searchObj.date_period"
                    :options="date_periods"
                    searchable="true"
                    placeholder="Select"
                    v-on:click="searchObj.from_date = ''; searchObj.to_date = ''; searchObj.start_date = ''; searchObj.end_date = ''"
                  />
                </div>
              </div>
            </div>
            <hr />

            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting"
                            id="id-id"
                            v-on:click="sorting('id', 'id-id')"
                          >
                            Sr No
                          </th>
                          <th>News Url</th>
                          <th>Headline</th>
                          <th>Publication Date</th>

                          <th>Publish</th>
                          <th>Type</th>
                          <th
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1 ||
                              accessObject?.is_publish == 1
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td>
                            {{
                              ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                              index +
                              1
                            }}
                          </td>
                          <td>
                            {{ $helperService.getText(data.news_url, 50) }}
                          </td>
                          <td>
                            {{ $helperService.getText(data.headline, 50) }}
                          </td>
                          <td>{{ data.published_date }}</td>

                          <td>{{ data.publish == "Y" ? "Yes" : "No" }}</td>
                          <td>
                            {{
                                data.topic && data.topic.topic_name ? data.topic.topic_name : ""
                            }}
                          </td>
                          <td
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1 ||
                              accessObject?.is_publish == 1
                            "
                          >
                            <a
                              v-if="accessObject?.is_edit == 1"
                              class="edit-btn btn-style cursor-pointer"
                              v-on:click="
                                $router.push(
                                  '/edit-deals-transaction/' + data.id
                                )
                              "
                              >Edit</a
                            >
                            <a
                              v-if="accessObject?.is_delete == 1"
                              class="delete-btn btn-style cursor-pointer"
                              v-on:click="showDeletePopup(data)"
                              >Delete</a
                            >
                            <a
                              v-show="
                                data.publish == 'Y' &&
                                accessObject?.is_publish == 1
                              "
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="updatepublishstatus('N', data.id)"
                              >Unpublish</a
                            >
                            <a
                              v-show="
                                data.publish == 'N' &&
                                accessObject?.is_publish == 1
                              "
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="updatepublishstatus('Y', data.id)"
                              >Published</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      @remove="deleteRecord($event)"
      @get-list="getList(0)"
      ref="deleteItem"
    />
  </div>

  <!-- Offcanvas start -->
  <!-- Overlay for offcanvas start -->
  <div v-if="isCanvasOpen" class="offcanvas-overlay"></div>
  <!-- Overlay for offcanvas end -->
  <div class="offcanvas" :class="{ show: isCanvasOpen }">
    <div class="offcanvas-header">
      <h5 class="mb-0">Compose Email</h5>
      <button type="button" class="close" @click="closeOffcanvas">&times;</button>
    </div>

    <div class="offcanvas-body">
      <!-- Tabs -->
      <ul class="nav nav-tabs" style="cursor: pointer;">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'email' }"
            @click="activeTab = 'email'"
          >
            Email
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'preview' }"
            @click="activeTab = 'preview'"
          >
            Preview
          </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content mt-3">
        <!-- Email Tab -->
        <div v-show="activeTab === 'email'" style="text-align: left;">
          <form>
            <div class="form-group">
              <label>To</label>
              <input
                type="text"
                class="form-control"
                v-model="emaildetails.to"
                placeholder="Enter email or leave empty if using group"
              />
            </div>
            <div class="text-center my-2 fw-bold">— OR —</div>
            <div class="form-group">
              <label class="label">Group Name</label>
              <Multiselect
                v-model="emaildetails.email_group_id"
                :options="group_name_list"
                label="name"
                valueProp="id"
                trackBy="name"
                mode="single"
                searchable="true"
                placeholder="Select"
              />
            </div>
            <div class="form-group">
              <label class="mb-0">Subject</label>
              <input
                type="text"
                class="form-control"
                v-model="emaildetails.subject"
              />
            </div>
          </form>
        </div>

        <!-- <div v-show="activeTab === 'preview'">
          <div v-if="isPreviewLoading" style="text-align:center; padding:40px;">
            <img src="/img/loader.gif" alt="Loading..." style="height:48px;" />
          </div>
          <div v-else v-html="emaildetails.body" style="background-color: #f9f9f9; padding: 10px; min-height: 200px;">
          </div>
        </div> -->

        <!-- Preview Tab -->
        <div v-show="activeTab === 'preview'" style="min-height: 200px;">
          <iframe
            v-if="!isPreviewLoading"
            :srcdoc="emaildetails.body"
            style="width: 100%; height: 80vh; border: none; overflow: auto;"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-scripts allow-top-navigation-by-user-activation"
          ></iframe>
          <div v-else style="text-align:center; padding:40px;">
            <img src="/img/loader.gif" alt="Loading..." style="height:48px;" />
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div v-show="activeTab === 'email'" class="text-center mt-3">
        <button type="submit" class="fill-btn w-auto px-4" @click="sendEmail" :disabled="sendLoading">
          <span v-if="sendLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          <span v-if="!sendLoading">Send</span>
          <span v-else>Sending...</span>
        </button>&nbsp;
        <button type="button" class="fill-btn w-auto px-4" @click="closeOffcanvas">
          Cancel
        </button>
      </div>
    </div>
  </div>
  <!-- Offcanvas end -->  
  <!-- Template Heading Modal -->
  <TextModal ref="textModal">
    <!-- <Form ref="practiceForm" @submit="uploadDocument()"> -->
    <div class="modal-header">
      <h5 class="modal-title">Heading</h5>
      <button
        type="button"
        class="close"
        v-on:click="$refs.textModal.closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="text-center mb-4">
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                v-model="searchObj.template_heading"
                placeholder="Enter Template Heading"
                required
              />
            </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        id="cancle-button"
        class="btn btn-secondary position-relative w-auto px-4"
        data-dismiss="modal"
        v-on:click="$refs.textModal.closeModal">
        Cancel
      </button>
      <button
        v-on:click="$refs.textModal.closeModal"
        id="document-button"
        type="button"
        class="btn btn-primary position-relative w-auto mt-0 mb-0 px-4">
        Submit
      </button>
    </div>

    <!-- </Form> -->
  </TextModal>  

</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
import datepicker from "vue3-datepicker";
import { Field } from "vee-validate";
import moment from "moment";
import TextModal from "@/components/TextModal";

export default {
  name: "Publication",
  components: {
    ErrorComponent,
    TextModal,
    DeleteModal,
    Pagination,
    Multiselect,
    datepicker,
    Field
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Deals & Transaction"),
      role: localStorage.getItem("role"),
      loader: true,
      offset: -1,
      list: [],
      showSubsectorDropdown: false,
      sendLoading: false,
      isPreviewLoading: false,
      downloadHtmlLoading: false,      
      is_show: false,
      isCanvasOpen: false,
      isDownloadHtml: false, // Flag to indicate HTML download
      activeTab: "email",
      companyKeyword: "",
      topicKeyword: "",
      jobFunctionKeyword: "",
      companyList: [],
      industryList: [],
      dealStageList: [],
      topicList: [],
      cityList: [],
      jobFunctionList: [],
      subsectorsList: [],
      regionList: [],
      searchObj: {
        from_date: "",
        to_date: "",
        topic_id: "",
        country_id: "",
        company_type: "",
        job_function_id_new: "",
        region_id_new: "",
        deal_stage_id: "",
        date_period: "",
        industry_id: "",
        company_id: "",
        response_type: "",
        subsector_id: "",
        template_heading: "",
      },
      emaildetails: {
        to: "",
        email_group_id: "",
        subject: "",
        body: "",
        type: "DEALS_TRANSACTION",
        filter_criteria : "" // The request data will be stored inside this
      },      
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      date_periods: [
        "Last Month",
        "Last 3 Month",
        "Last 6 Month",
        "Last 1 Year",
      ],
    };
  },
  mounted() {
    this.getList(0);
    this.getDynamicHeading();
    this.companylist();
    this.CityList();
    this.jobFunctionlist();
    this.getRegionlist();
    this.getindustrylist();
    this.getDealStageList();
    this.groupNameList();
    this.topiclist();
  },
  methods: {
     getAdvanceSearch() {
      this.is_show = !this.is_show;
    },
    updatepublishstatus(status, id) {
      var obj = {};
      obj.id = id;
      obj.publish = status;
      this.$api
        .putAPI({
          _action: "/deals/transacction",
          _body: obj,
        })
        .then(() => {
          this.getList(0);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_id = res.industry_id;
            if (this.searchObj.industry_id) {
              this.getSubsectorList(this.searchObj.industry_id);
              this.searchObj.subsector_id = res.subsector_id;
            }            
          })
          .catch(() => {});
      }
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.getindustrylist();
    },
    searchTopicName(e) {
      this.topicKeyword = e;
      this.topiclist();
    },
    showHeadingPopup() {
      this.searchObj.template_heading = "";
      this.getDynamicHeading();
      this.$refs.textModal.showModal();
    },
    getDynamicHeading() {
      this.$api
        .getAPI({
          _action: "/deals/dynamic-heading",
          _body: this.searchObj,
        })
        .then((res) => {
          this.searchObj.template_heading = res;
        })
        .catch(() => {});
    },    
    openOffcanvas() {
      this.activeTab = "email";
      this.isCanvasOpen = true;
      this.isPreviewLoading = true;
      // this.searchObj.response_type = "preview_html";
      this.getList(0, null, null, 'preview_html');
    },
    downloadHtml() {
      // this.searchObj.response_type = "download_html";
      this.isDownloadHtml = true; // mark that we want to download
      this.downloadHtmlLoading = true;
      this.getList(0, null, null, 'download_html'); // this will trigger getHtml()
    },
    downloadHtmlFile(content) {
      const blob = new Blob([content], { type: "text/html" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "deals_transaction.html";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    closeOffcanvas() {
      this.isCanvasOpen = false;
      this.searchObj.response_type = "";
      this.emaildetails.to = "";
      this.emaildetails.email_group_id = "";
      this.emaildetails.subject = "";
      this.emaildetails.body = "";
      this.emaildetails.type = "DEALS_TRANSACTION";
      this.emaildetails.filter_criteria = "";
    },
    groupNameList() {
      this.$api
        .getAPI({
          _action: "/email_group/list_nopagination",
        })
        .then((res) => {
          this.group_name_list = res;
        })
        .catch(() => {});
    },
    downloadPdf(orderBy, sortBy, page) { 
      console.log('deals-', orderBy, sortBy, page);
      // if (orderBy) this.searchObj.order_by = orderBy;
      // if (sortBy)  this.searchObj.sort_by = ;
      this.searchObj.order_by = "";
      this.searchObj.sort_by = "";
      this.searchObj.offset = "";
      this.santiseValueSearch();
      // if (this.offset != page) {        
      //   this.searchObj.offset = page;
      // } else {
      //   this.searchObj.offset = page;
      // }
      this.$api
        .getAPI({
          _action: "/deals/downloadable-url",
          _body: this.searchObj,
        })
        .then((res) => {
          if (res && res.downloadable_url) {
            window.open(res.downloadable_url, "_blank");
          } else {
            this.$notify({
              type: "error",
              text: "PDF generation failed. Please try again.",
            });
          }
        })
        .catch(() => {
          this.$notify({
            type: "error",
            text: "PDF generation failed. Please try again.",
          });
        });
    },    
    sendEmail() {
      // Validation: Either 'to' OR 'email_group_id' must be filled
      if (!this.emaildetails.to && !this.emaildetails.email_group_id) {      
        this.$notify({
            type: "error",
            text: "Please enter a recipient email or select a group.",
          });
        return;
      }
      if (this.emaildetails.to && this.emaildetails.email_group_id) {
        this.$notify({
            type: "error",
            text: "Please fill only one: 'To' OR 'Group'.",
          });
        return;
      }
      this.sendLoading = true;
      this.$api
        .postAPI({
          _action: "/email_logs/add",
          _body: this.emaildetails,
        })
        .then((res) => {
          this.sendLoading = false;
          this.$notify({
            type: "success",
            text: res.message,
          });
          
          this.closeOffcanvas();
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, " ");
          }
        })
        .catch(() => {
          this.sendLoading = false;
        });
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = res;
        })
        .catch(() => {});
    },
    industryChange(e) {
      if (e) {
        this.getSubsectorList(e);
      } else {
        this.searchObj.subsector_id = "";
        this.showSubsectorDropdown = false;
      }
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          this.subsectorsList = res.list;
          
          if (this.subsectorsList.length > 0) {
            this.showSubsectorDropdown = true;
          } else {
            this.searchObj.subsector_id = "";
            this.showSubsectorDropdown = false;
          }
        })
        .catch(() => { });
    },    
    getindustrylist() {
      var obj = {};
      if (this.industryKeyword) {
        obj.keyword = this.industryKeyword;
      }      
      this.$api
        .getAPI({
          _action: "/industry/list",
          _body: obj,
        })
        .then((res) => {
          this.industryList = res;
        })
        .catch(() => {});
    },
     topiclist() {
      var obj = {};
      if (this.topicKeyword) {
        obj.keyword = this.topicKeyword;
      }
      this.$api
        .getAPI({
          _action: "/deals-type/list",
          _body: obj,
        })
        .then((res) => {
          this.topicList = res;
        })
        .catch(() => {});
    },
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = res;
        })
        .catch(() => {});
    },
    jobFunctionlist() {
      var obj = {};
      if (this.jobFunctionKeyword) {
        obj.keyword = this.jobFunctionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = res;
        })
        .catch(() => {});
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
     CityList() {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: obj,
        })
        .then((res) => {
          this.cityList = res;
        })
        .catch(() => {});
    },
     getRegionlist() {
      var obj = {};
      if (this.regionKeyword) {
        obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: obj,
        })
        .then((res) => {
          this.regionList = res;
        })
        .catch(() => {});
    },
    santiseValueSearch() {
      if (this.searchObj.from_date) {
        this.searchObj.start_date = moment(this.searchObj.from_date).format(
          "DD-MM-YYYY"
        );
      }
      if (this.searchObj.to_date) {
        this.searchObj.end_date = moment(this.searchObj.to_date).format(
          "DD-MM-YYYY"
        );
      }
      if (!this.searchObj.job_function_id_new) {
        this.searchObj.job_function_id_new = "";
      }
      if (!this.searchObj.region_id_new) {
        this.searchObj.region_id_new = "";
      }
      if (!this.searchObj.country_id) {
        this.searchObj.country_id = "";
      }
      if (!this.searchObj.company_type) {
        this.searchObj.company_type = "";
      }
      if (!this.searchObj.keyword) {
        this.searchObj.keyword = "";
      }
      if (!this.searchObj.industry_id) {
        this.searchObj.industry_id = "";
      }
      if (!this.searchObj.subsector_id) {
        this.searchObj.subsector_id = "";
      }
      if (!this.searchObj.topic_id) {
        this.searchObj.topic_id = "";
      }      
      if (!this.searchObj.company_id) {
        this.searchObj.company_id = "";
      }
      if (!this.searchObj.deal_stage_id) {
        this.searchObj.deal_stage_id = "";
      }
      if (!this.searchObj.date_period) {
        this.searchObj.date_period = "";
      }
      if (!this.searchObj.template_heading) {
        this.searchObj.template_heading = "";
      }      
    },
    getList(page, orderBy, sortBy, response_type) {  // Developer Note: If you change the getDealAndTransactionList then you should also change the getHtml because We are are creating pdf by the same filters.
      if (response_type) {
        this.searchObj.response_type = response_type;
        this.getHtml(page, orderBy, sortBy);
      } else {
        this.searchObj.response_type = "";
        this.getDealAndTransactionList(page, orderBy, sortBy);
      }      
    },
    getDealAndTransactionList(page, orderBy, sortBy) {      
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.santiseValueSearch();
      this.$api
        .getAPI({
          _action: "/deals/transacction/pagination/listv2",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject = this.$helperService.getAccessLevel(
            "Deals & Transaction"
          );
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "No deals transaction list available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.topic_id = "";
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_id = "";
      this.searchObj.company_id = "";
      this.searchObj.country_id = "";
      this.searchObj.company_type = "";
      this.searchObj.job_function_id_new = "";
      this.searchObj.region_id_new = "";
      this.emaildetails.to = "";
      this.emaildetails.email_group_id = "";
      this.emaildetails.subject = "";
      this.emaildetails.body = "";
      this.emaildetails.type = "DEALS_TRANSACTION"
      this.emaildetails.filter_criteria = "";      
      this.searchObj.subsector_id = "";
      this.showSubsectorDropdown = false;
      this.getDynamicHeading();
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal(
        "Delete Deals & Transaction",
        "Are you sure you want to delete",
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/deals/transacction/" + detail.id);
    },
    getHtml(page, orderBy, sortBy) {
      // this.$refs.errorComponent.updateListLoader(true);
      // this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.santiseValueSearch();
      this.emaildetails.filter_criteria = JSON.parse(JSON.stringify(this.searchObj));
      this.$api
        .getAPI({
          _action: "/deals/transacction/pagination/listv2",
          _body: this.searchObj,
        })
        .then((res) => {
          this.isPreviewLoading = false;
          this.downloadHtmlLoading = false;          
          if (this.isDownloadHtml) {
            this.downloadHtmlFile(res.result);
            this.isDownloadHtml = false; // reset the flag
          } else {
            this.emaildetails.body = res.result;
          }         
          this.searchObj.response_type = ""; 
          // this.loader = false;
          // this.list = res.list;
          // this.offset = res.next_offset;
          // this.accessObject = this.$helperService.getAccessLevel(
          //   "Deals & Transaction"
          // );
          // if (page == 0) {
          //   if (this.$refs.listPagination) {
          //     if (res.count != null && res.count > 0) {
          //       this.$refs.listPagination.setTotalCount(res.count);
          //     } else {
          //       this.$refs.listPagination.setTotalCount(0);
          //     }
          //   }
          // }
          // if (this.$refs.errorComponent) {
          //   this.$refs.errorComponent.setData(
          //     res,
          //     "No deals transaction list available"
          //   );
          //   this.$refs.errorComponent.updateListLoader(false);
          // }
        })
        .catch(() => {
          this.loader = false;
          this.isPreviewLoading = false;
          this.downloadHtmlLoading = false;          
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    }
  },
};
</script>
<style>
.offcanvas {
  position: fixed;
  top: 0;
  right: -100%;
  width: 75%;
  max-width: 100%;
  height: 100%;
  background: #fff;
  transition: right 0.3s ease-in-out;
  z-index: 1050;
  overflow-y: auto;
}
.offcanvas.show {
  right: 0;
}
.offcanvas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #ddd;
}
.offcanvas-body {
  padding: 1rem;
}
.close {
  background: none;
  border: none;
  font-size: 1.5rem;
}

.offcanvas-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1049;
}

</style>